import { useLocation } from 'react-router-dom'
import React from "react";

export function useQuery () {
    return new URLSearchParams(useLocation().search)
}

export function useEffectAfterMount(cb, dependencies) {
    const justMounted = React.useRef(true)
    React.useEffect(() => {
        if (!justMounted.current) {
            return cb()
        }
        justMounted.current = false
    }, dependencies)
}